import { useRouter } from 'expo-router'
import Icon from '~/components/Icon.tsx'
import { Button } from '~/components/ui/button'
import { cn } from '~/lib/utils.ts'

export default function CloseButton({
  className,
  onPress,
  iconClassName,
  variant = 'outline',
}: {
  className?: string
  iconClassName?: string
  onPress?: () => undefined | boolean
  variant?: 'outline' | 'destructive'
}) {
  const router = useRouter()

  return (
    <Button
      variant={variant}
      className={cn('absolute right-4 top-4', className)}
      size="icon"
      onPress={() => {
        const result = onPress?.()

        if (result === false) {
          return
        }

        if (router.canGoBack()) {
          router.back()
        } else {
          router.replace('/(authenticated)')
        }
      }}>
      <Icon name="close" size={20} className={cn(iconClassName)} />
    </Button>
  )
}
